import { render, staticRenderFns } from "./ElButtonMini.vue?vue&type=template&id=07b5e37b&scoped=true"
import script from "./ElButtonMini.vue?vue&type=script&lang=js"
export * from "./ElButtonMini.vue?vue&type=script&lang=js"
import style0 from "./ElButtonMini.vue?vue&type=style&index=0&id=07b5e37b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b5e37b",
  null
  
)

export default component.exports